<template>
  <component
    :is="tag"
    :type="htmlType"
    :href="href"
    :target="target"
    :disabled="disabled || loading"
    class="appearance-none flex items-center justify-center leading-5 py-2 border text-sm font-medium rounded-md focus:outline-hidden focus:ring-2 focus:ring-offset-2"
    :class="{
      'border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-blue': type === 'default',
      'text-gray-700 bg-transparent hover:text-blue focus:ring-blue border-transparent':
        type === 'link',
      'text-black bg-transparent hover:text-blue hover:border-blue border-black':
        type === 'outline',
      'text-white bg-blue hover:bg-blue-600 focus:ring-blue border-transparent': type === 'primary',
      'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 border-transparent':
        type === 'danger',
      'border-red-300 text-red-600 bg-white hover:bg-red-50 focus:ring-red-500':
        type === 'danger.secondary',
      'opacity-50 cursor-not-allowed': disabled || loading,
      'px-4': $slots.default,
      'px-2': !$slots.default,
      'w-full': block,
      'shadow-xs': type !== 'link',
    }"
  >
    <component
      :is="loading ? 'LoadingIcon' : leadingIcon"
      v-if="leadingIcon || loading"
      :key="loading"
      class="h-5 w-5"
      :class="{ 'mr-2': $slots.default && !hideLabel }"
    />
    <slot v-if="!hideLabel" />
  </component>
</template>

<script>
import { useBreakpoints } from '@/api/useBreakpoints'

export default {
  name: 'TButton',
  props: {
    as: {
      type: String,
      default: 'button',
    },
    leadingIcon: {
      type: String,
      default: '',
    },
    trailingIcon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'default',
      validator: (value) => {
        return ['default', 'primary', 'danger', 'danger.secondary', 'link', 'outline'].includes(
          value,
        )
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    htmlType: {
      type: String,
      default: 'button',
      validator: (value) => {
        return ['button', 'submit'].includes(value)
      },
    },
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_self',
    },
    block: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    responsive: {
      type: String,
      default: '',
    },
    responsiveReverse: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const tag = props.href && props.as !== 'a' ? 'Link' : props.as
    const breakpoints = useBreakpoints()
    const hideLabel = props.responsive
      ? props.responsiveReverse
        ? breakpoints.greater(props.responsive)
        : breakpoints.smaller(props.responsive)
      : false
    return {
      tag,
      hideLabel,
    }
  },
}
</script>
